export const useSledLiveChannelName = (tournamentId: string): string =>
    tournamentId ? `${tournamentId}_LIVE_SLI_JSON` : undefined;

export const getSledMeasureBoxChannelName = (tournamentId: string) =>
    tournamentId ? `${tournamentId}_MESSBOX_JSON` : undefined;
